/**
 * Copy de Gastos (factura + pagos). Vos, como en el mostrador.
 * Menú: «Gastos».
 */
export const expenseErpCopy = {
  tabBills: 'Facturas',
  tabPayments: 'Pagos',

  kpiBilledTotal: 'Total',
  kpiBalanceDue: 'Falta pagar',
  kpiPaidTotal: 'Pagado',
  kpiPaymentCount: 'Pagos',
  kpiCashOutflow: 'Salen de caja',

  paymentStatus: {
    unpaid: 'A pagar',
    partial: 'Pago parcial',
    paid: 'Pagada',
  } as const,

  paymentStatusFilter: {
    all: 'Todos',
    unpaid: 'A pagar',
    partial: 'Pago parcial',
    paid: 'Pagadas',
    voided: 'Anuladas',
  } as const,

  statusVoided: 'Anulada',

  billDetailTitle: 'Factura',
  billDetailKicker: 'Gastos · Factura',
  newBillTitle: 'Nueva factura',
  registerPaymentTitle: 'Registrar pago',
  paymentsSectionTitle: 'Pagos de esta factura',
  paymentsEmptyTitle: 'Sin pagos',
  paymentsEmptyMessage: 'Todavía no hay pagos en esta factura.',

  actionNewBill: 'Nueva factura',
  actionRegisterPayment: 'Registrar pago',
  actionVoidBill: 'Anular factura',
  actionRegisterAndPay: 'Registrar y pagar',

  columnTotal: 'Total',
  columnPaid: 'Pagado',
  columnBalance: 'Saldo',
  columnStatus: 'Estado',
  columnDueDate: 'Vencimiento',
  kpiOverdue: 'Vencidas',
  dueStatusFilter: {
    all: 'Todas',
    overdue: 'Vencidas',
    due_soon: 'Vence en 7 días',
    no_due_date: 'Sin vencimiento',
  } as const,

  attachmentLabel: 'Comprobante',
  attachmentAddLabel: 'Adjuntar comprobante',
  attachmentRemoveLabel: 'Quitar comprobante',
  attachmentViewLabel: 'Ver comprobante',
  attachmentDeleteLabel: 'Eliminar',

  stalePaymentsBanner: 'Los pagos del equipo pueden estar viejos. Conectate para actualizar.',

  futureDateWarning:
    'La fecha es futura — va a quedar fuera del filtro por defecto. Para verla, elegí "Todos" en el filtro de fechas.',
  negativeAmountHint: 'El signo "-" no aplica: los gastos se cargan en positivo.',
  voidReasonMinHint: 'Mínimo 3 caracteres.',

  emptyBillsTitle: 'Todavía no cargaste facturas',
  emptyBillsSubtitle: 'Cuando un proveedor te factura o pagás un servicio, cargalo acá y seguí qué falta pagar.',
  emptyBillsFilteredTitle: 'No hay facturas acá',
  emptyBillsFilteredSubtitle: 'Con estos filtros no aparece nada. Probá otro rango o limpiá los filtros.',
  emptyBillsSearchTitle: 'Sin resultados',
  emptyBillsSearchSubtitle: 'Nada coincide con esa búsqueda.',
  emptyPaymentsTitle: 'Todavía no hay pagos registrados',
  emptyPaymentsSubtitle: 'Los pagos de facturas aparecen acá.',
  emptyPaymentsFilteredTitle: 'No hay pagos acá',
  emptyPaymentsFilteredSubtitle: 'Con estos filtros no aparece nada. Probá otro rango o limpiá los filtros.',
  emptyPaymentsSearchTitle: 'Sin resultados',
  emptyPaymentsSearchSubtitle: 'Nada coincide con esa búsqueda.',
  clearFiltersAction: 'Limpiar filtros',

  supplierPaymentMerchandiseHint:
    '¿Es mercadería de un proveedor? Cargala en Compras (Comprar ahora o recibir pedido). Acá van servicios y gastos sueltos.',
  duplicatePurchaseLinkedBanner:
    'Ya registraste esta compra en Compras. Pagala desde el detalle del pedido si falta efectivo en caja. No la cargues otra vez acá.',
  duplicateSimilarManualBanner:
    'Ya hay una factura parecida (mismo proveedor y monto). Revisá si no es la misma compra antes de guardar.',
  purchaseLinkedBillBanner:
    'Esta factura la genera Compras. Para anularla o corregir el monto, usá el pedido en Compras.',
  purchaseLinkedBillVoidBlocked:
    'No podés anular acá una factura ligada a una compra. Andá a Compras o anulá la recepción desde el pedido.',
} as const;
